import { createAction, createReducer } from '@reduxjs/toolkit';

const loggedVerify = () => {
  if (localStorage.getItem('loginToken') === null) {
    return {
      isAuthenticated: false,
      token: null,
    };
  }
  return {
    isAuthenticated: true,
    token: localStorage.getItem('loginToken'),
  };
};

const INITIAL_STATE = loggedVerify();

export const loginAction = createAction<string>('@loginPage/LOGIN');
export const logoutAction = createAction('@loginPage/LOGOUT');

const loginAuthReducer = createReducer(INITIAL_STATE, {
  [loginAction.type]: (state, action) => ({
    ...state,
    isAuthenticated: true,
    token: action.payload,
  }),
  [logoutAction.type]: (state) => ({
    ...state,
    isAuthenticated: false,
    token: null,
  }),
});

export default loginAuthReducer;
